var React = require('react');

function Times (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.1213 16L18.5312 9.59L19.8531 8.26812C20.0481 8.07312 20.0481 7.75625 19.8531 7.56125L18.4387 6.14688C18.2437 5.95188 17.9269 5.95188 17.7319 6.14688L10 13.8787L2.26813 6.14625C2.07313 5.95125 1.75625 5.95125 1.56125 6.14625L0.14625 7.56063C-0.04875 7.75563 -0.04875 8.0725 0.14625 8.2675L7.87875 16L0.14625 23.7319C-0.04875 23.9269 -0.04875 24.2437 0.14625 24.4387L1.56062 25.8531C1.75562 26.0481 2.0725 26.0481 2.2675 25.8531L10 18.1213L16.41 24.5312L17.7319 25.8531C17.9269 26.0481 18.2437 26.0481 18.4387 25.8531L19.8531 24.4387C20.0481 24.2437 20.0481 23.9269 19.8531 23.7319L12.1213 16Z","fill":"currentColor"}));
}

Times.defaultProps = {"width":"20","height":"32","viewBox":"0 0 20 32","fill":"none"};

module.exports = Times;

Times.default = Times;
